import { supabase } from './supabaseClient';
import { Orcamento, OrcamentoInput } from './types';

export const getOrcamentoVsRealizado = async (obraId: number): Promise<Orcamento[]> => {
    const { data, error } = await supabase.rpc('get_orcamento_vs_realizado', {
        p_obra_id: obraId
    });

    if (error) throw error;
    return data;
};

export const upsertOrcamento = async (input: OrcamentoInput) => {
    const { data, error } = await supabase.rpc('upsert_orcamento', {
        p_obra_id: input.obra_id,
        p_categoria_id: input.categoria_id,
        p_valor_previsto: input.valor_previsto,
        p_observacoes: input.observacoes
    });

    if (error) throw error;
    return data;
};
